import React, { useRef, useEffect } from 'react';
import CameraPhoto, { FACING_MODES } from 'jslib-html5-camera-photo';
import Compressor from 'compressorjs';
import classNames from 'classnames/bind';
import { getProperty } from '../../../../modules/ajio-util/properties';
import styles from './index.pcss';

const cx = classNames.bind(styles);

const WebCamera = props => {
  const { onTakePhoto } = props;
  const cameraPhotoRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    cameraPhotoRef.current = new CameraPhoto(videoRef.current);
  }, []);

  const startCamera = (idealFacingMode, idealResolution) => {
    cameraPhotoRef.current
      .startCamera(idealFacingMode, idealResolution)
      .then(() => {
        // console.log('camera is started !');
      })
      .catch(error => {
        // console.error('Camera not started!', error);
      });
  };

  function dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  const takePhoto = () => {
    const config = {
      sizeFactor: 1
    };
    const dataUri = cameraPhotoRef.current.getDataUri(config);
    stopCamera();
    if (dataUri) {
      const blob = dataURItoBlob(dataUri);
      if (blob instanceof Blob) {
        new Compressor(blob, {
          quality: 0.6, // Set the image quality to 60%
          success(result) {
            onTakePhoto(result);
          },
          error(err) {
            // console.log('file error', err);
            // console.log(err.message);
          }
        });
      }
    }
  };

  const stopCamera = () => {
    cameraPhotoRef.current
      .stopCamera()
      .then(() => {
        // console.log('Camera stopped!');
      })
      .catch(error => {
        // console.log('No camera to stop!:', error);
      });
  };

  useEffect(() => {
    handleClick();
  }, []);

  const handleClick = () => {
    let facingMode = FACING_MODES.ENVIRONMENT;
    startCamera(facingMode, {});
  };

  return (
    <div className={cx('modal')}>
      <video style={{ width: '100vw', height: '95vh' }} ref={videoRef} autoPlay />
      <div className={cx('shutter')}>
        <button className={cx('shutter-img')} onClick={takePhoto}>
          <img alt="Camera click icon" src={`${getProperty('imageBaseUrl')}/static/img/cameraShutter.svg`} />
        </button>
      </div>
    </div>
  );
};

export default WebCamera;
